import React, { useState } from 'react';
import { AnimatedSection } from './AnimatedSection';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function ClosingSection() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <section className="w-full px-6 py-10 md:py-14" data-id="element-11">
      <div className="max-w-2xl mx-auto" data-id="element-12">
        <AnimatedSection data-id="element-13">
          <div className="w-12 h-px bg-sand mx-auto mb-8" data-id="element-14" />
        </AnimatedSection>

        <AnimatedSection data-id="element-15">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal leading-tight mb-5" data-id="element-16">
            Si tu casa te está ganando hoy…
          </h2>
        </AnimatedSection>

        <AnimatedSection delay={0.1} data-id="element-17">
          <div className="space-y-3 text-charcoal/80 text-base md:text-lg leading-relaxed mb-6" data-id="element-18">
            <p data-id="element-19">No esperes a "tener energía".</p>
            <p className="font-medium text-charcoal" data-id="element-20">
              La energía aparece después de la primera acción pequeña.
            </p>
            <p data-id="element-21">
              RESET 48 es esa primera acción…{' '}
              <span className="text-teal font-medium" data-id="element-22">con mapa.</span>
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.15} data-id="element-23">
          <div className="text-center mb-6" data-id="element-24">
            <a href="https://tucasareset.com/cart/52058806419778:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="inline-block bg-teal text-white font-semibold text-lg px-10 py-4 rounded-full transition-transform duration-200 hover:scale-105 hover:bg-teal-dark focus:outline-none focus:ring-2 focus:ring-teal focus:ring-offset-2 focus:ring-offset-cream" role="button" data-id="element-25">
              Empieza por el primer bloque: 10 minutos de TRASH
            </a>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.2} data-id="element-26">
          <div className="text-center space-y-1" data-id="element-27">
            <p className="text-warm-gray text-base italic" data-id="element-28">
              No perfecto. No completo.
            </p>
            <p className="text-charcoal font-serif text-xl" data-id="element-29">Solo empezar.</p>
          </div>
        </AnimatedSection>

        {/* Footer */}
        <AnimatedSection delay={0.25} data-id="element-30">
          <div className="mt-12 pt-6 border-t border-cream-dark text-center space-y-3" data-id="element-31">
            <p className="text-warm-gray/50 text-xs" data-id="element-32">
              © {new Date().getFullYear()} RESET 48. Todos los derechos
              reservados.
            </p>
            <button onClick={() => setShowPrivacy(true)} className="text-warm-gray/50 text-xs underline underline-offset-2 hover:text-teal transition-colors duration-200 focus:outline-none focus:text-teal" data-id="element-33">
              Política de Privacidad
            </button>
            <span className="text-warm-gray/30 text-xs" data-id="element-34">·</span>
            <button onClick={() => setShowTerms(true)} className="text-warm-gray/50 text-xs underline underline-offset-2 hover:text-teal transition-colors duration-200 focus:outline-none focus:text-teal" data-id="element-35">
              Términos y Condiciones
            </button>
          </div>
        </AnimatedSection>
      </div>

      {/* Privacy Policy Modal */}
      <AnimatePresence data-id="element-36">
        {showPrivacy && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-37">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-charcoal/40 backdrop-blur-sm" data-id="element-38" />

            {/* Modal */}
            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 10,
          scale: 0.97
        }} transition={{
          duration: 0.3,
          ease: [0.25, 0.1, 0.25, 1]
        }} onClick={e => e.stopPropagation()} className="relative bg-cream rounded-2xl shadow-xl max-w-lg w-full max-h-[80vh] overflow-y-auto border border-cream-dark" data-id="element-39">
              {/* Close button */}
              <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-cream-dark/50 text-warm-gray hover:text-charcoal hover:bg-cream-dark transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-teal" aria-label="Cerrar" data-id="element-40">
                <XIcon className="w-4 h-4" data-id="element-41" />
              </button>

              <div className="p-8 md:p-10" data-id="element-42">
                <h3 className="font-serif text-2xl text-charcoal mb-6" data-id="element-43">
                  Política de Privacidad
                </h3>

                <div className="space-y-5 text-charcoal/70 text-sm leading-relaxed" data-id="element-44">
                  <p data-id="element-45">
                    <strong className="text-charcoal font-medium" data-id="element-46">
                      Última actualización:
                    </strong>{' '}
                    {new Date().toLocaleDateString('es-ES', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
                  </p>

                  <div data-id="element-47">
                    <h4 className="text-charcoal font-medium mb-2" data-id="element-48">
                      1. Información que recopilamos
                    </h4>
                    <p data-id="element-49">
                      Al adquirir RESET 48, recopilamos únicamente la
                      información necesaria para procesar tu compra: nombre y
                      dirección de correo electrónico. No almacenamos datos de
                      pago; estos son procesados de forma segura por nuestro
                      proveedor de pagos.
                    </p>
                  </div>

                  <div data-id="element-50">
                    <h4 className="text-charcoal font-medium mb-2" data-id="element-51">
                      2. Uso de la información
                    </h4>
                    <p data-id="element-52">Tu información se utiliza exclusivamente para:</p>
                    <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-53">
                      <li data-id="element-54">Entregar el producto digital adquirido.</li>
                      <li data-id="element-55">Enviar comunicaciones relacionadas con tu compra.</li>
                    </ul>
                    <p className="mt-2" data-id="element-56">
                      No vendemos, alquilamos ni compartimos tu información
                      personal con terceros con fines comerciales.
                    </p>
                  </div>

                  <div data-id="element-57">
                    <h4 className="text-charcoal font-medium mb-2" data-id="element-58">
                      3. Protección de datos
                    </h4>
                    <p data-id="element-59">
                      Implementamos medidas de seguridad razonables para
                      proteger tu información personal contra acceso no
                      autorizado, alteración o destrucción.
                    </p>
                  </div>

                  <div data-id="element-60">
                    <h4 className="text-charcoal font-medium mb-2" data-id="element-61">
                      4. Cookies
                    </h4>
                    <p data-id="element-62">
                      Este sitio puede utilizar cookies esenciales para su
                      funcionamiento. No utilizamos cookies de seguimiento
                      publicitario.
                    </p>
                  </div>

                  <div data-id="element-63">
                    <h4 className="text-charcoal font-medium mb-2" data-id="element-64">
                      5. Tus derechos
                    </h4>
                    <p data-id="element-65">
                      Puedes solicitar la eliminación de tus datos personales en
                      cualquier momento. También puedes solicitar acceso a la
                      información que tenemos sobre ti.
                    </p>
                  </div>

                  <div data-id="element-66">
                    <h4 className="text-charcoal font-medium mb-2" data-id="element-67">
                      6. Cambios a esta política
                    </h4>
                    <p data-id="element-68">
                      Nos reservamos el derecho de actualizar esta política.
                      Cualquier cambio será publicado en esta página.
                    </p>
                  </div>
                </div>

                <div className="mt-8 pt-6 border-t border-cream-dark" data-id="element-69">
                  <button onClick={() => setShowPrivacy(false)} className="w-full bg-cream-dark/60 text-charcoal font-medium text-sm py-3 rounded-full hover:bg-cream-dark transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-teal" data-id="element-70">
                    Cerrar
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Terms & Conditions Modal */}
      <AnimatePresence data-id="element-71">
        {showTerms && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-72">
            <div className="absolute inset-0 bg-charcoal/40 backdrop-blur-sm" data-id="element-73" />

            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 10,
          scale: 0.97
        }} transition={{
          duration: 0.3,
          ease: [0.25, 0.1, 0.25, 1]
        }} onClick={e => e.stopPropagation()} className="relative bg-cream rounded-2xl shadow-xl max-w-lg w-full max-h-[80vh] overflow-y-auto border border-cream-dark" data-id="element-74">
              <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-cream-dark/50 text-warm-gray hover:text-charcoal hover:bg-cream-dark transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-teal" aria-label="Cerrar" data-id="element-75">
                <XIcon className="w-4 h-4" data-id="element-76" />
              </button>

              <div className="p-8 md:p-10" data-id="element-77">
                <h3 className="font-serif text-2xl text-charcoal mb-6" data-id="element-78">
                  Términos y Condiciones
                </h3>

                <div className="space-y-5 text-charcoal/70 text-sm leading-relaxed" data-id="element-79">
                  <p data-id="element-80">
                    <strong className="text-charcoal font-medium" data-id="element-81">
                      Última actualización:
                    </strong>{' '}
                    {new Date().toLocaleDateString('es-ES', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
                  </p>

                  <div data-id="element-82">
                    <h4 className="text-charcoal font-medium mb-2" data-id="element-83">
                      1. Producto digital
                    </h4>
                    <p data-id="element-84">
                      RESET 48 es un producto digital en formato PDF. Al
                      completar la compra, recibirás acceso inmediato para
                      descargar el archivo. Este producto no incluye asesoría
                      personalizada, sesiones en vivo ni soporte continuo.
                    </p>
                  </div>

                  <div data-id="element-85">
                    <h4 className="text-charcoal font-medium mb-2" data-id="element-86">
                      2. Política de reembolso
                    </h4>
                    <p data-id="element-87">
                      Debido a la naturaleza digital del producto y su entrega
                      inmediata, no se aceptan devoluciones ni reembolsos una
                      vez realizada la descarga. Te recomendamos leer la
                      descripción completa del producto antes de realizar tu
                      compra.
                    </p>
                  </div>

                  <div data-id="element-88">
                    <h4 className="text-charcoal font-medium mb-2" data-id="element-89">
                      3. Uso permitido
                    </h4>
                    <p data-id="element-90">
                      El contenido de RESET 48 es para uso personal y exclusivo
                      del comprador. Queda prohibida su reproducción,
                      distribución, reventa o compartición total o parcial sin
                      autorización expresa.
                    </p>
                  </div>

                  <div data-id="element-91">
                    <h4 className="text-charcoal font-medium mb-2" data-id="element-92">
                      4. Propiedad intelectual
                    </h4>
                    <p data-id="element-93">
                      Todo el contenido del PDF, incluyendo textos, diseños,
                      gráficos y estructura, está protegido por derechos de
                      autor. La compra otorga una licencia de uso personal, no
                      la propiedad del contenido.
                    </p>
                  </div>

                  <div data-id="element-94">
                    <h4 className="text-charcoal font-medium mb-2" data-id="element-95">
                      5. Limitación de responsabilidad
                    </h4>
                    <p data-id="element-96">
                      RESET 48 ofrece sugerencias y un protocolo de organización
                      del hogar. Los resultados pueden variar según las
                      circunstancias individuales. No garantizamos resultados
                      específicos y no nos hacemos responsables por el uso que
                      se le dé al contenido.
                    </p>
                  </div>

                  <div data-id="element-97">
                    <h4 className="text-charcoal font-medium mb-2" data-id="element-98">
                      6. Modificaciones
                    </h4>
                    <p data-id="element-99">
                      Nos reservamos el derecho de modificar estos términos en
                      cualquier momento. Los cambios serán efectivos desde su
                      publicación en esta página.
                    </p>
                  </div>
                </div>

                <div className="mt-8 pt-6 border-t border-cream-dark" data-id="element-100">
                  <button onClick={() => setShowTerms(false)} className="w-full bg-cream-dark/60 text-charcoal font-medium text-sm py-3 rounded-full hover:bg-cream-dark transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-teal" data-id="element-101">
                    Cerrar
                  </button>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}